import restCrudReducer from "../../../np-crud/store/restCrudReducer";
import * as actionTypes from "./actionTypes";

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: "TRANSLATE",
    entityName: "TRANSLATE"
});

const initialState = {
    ...crudInitialState,
    deletedExternalSystemSetting: {},
    deleting: false,
    saving: false, 
    progress: null,
    snackStart: false
};

const updateTranslations = (state, action) => {
    return {
        ...state,
        activeTranslations: action.translations
    };
};

const setDefaultLanguage = (state, action) => {
    return {
        ...state,
        DefaultLanguage: action.DefaultLanguage
    };
};

const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }

    // Handle other actions
    switch (action.type) {
        case actionTypes.SET_DEFAULT_TRANSLATION:
            return setDefaultLanguage(state, action);
        case 'TRANSLATE|PROGRESS':
            return { ...state, progress: action.progress, maxSize: action.maxSize, loadSize: action.loadSize, snackStart: action.snackStart };
        case "UPDATE_TRANSLATIONS":
            return updateTranslations(state, action);
        case "CORE|LOGOUT_SUCCESS":
        case "CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS":
            return initialState;
        default:
            return state;
    }
};

export default reducer;
